import { render, staticRenderFns } from "./mediaPlatformConfirm.vue?vue&type=template&id=5a066eb6&scoped=true&"
import script from "./mediaPlatformConfirm.vue?vue&type=script&lang=js&"
export * from "./mediaPlatformConfirm.vue?vue&type=script&lang=js&"
import style0 from "./mediaPlatformConfirm.vue?vue&type=style&index=0&id=5a066eb6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a066eb6",
  null
  
)

component.options.__file = "mediaPlatformConfirm.vue"
export default component.exports